// extracted by mini-css-extract-plugin
export default {"wrapper":"profile-edit_wrapper__-Jnzi"};